import Notification from "./Notification";

const data = {
    appList: [
        {
            name: "startups-edu-h5",
            entry: process.env.NODE_ENV === "development" ? "http://47.113.216.124:30010" : "https://h5.nowui.com/startups-edu-h5/",
            container: "#container",
            activeRule: "#/edu/",
            props: {
                Notification: Notification,
            },
        },
    ],
};

export default data;
